import { createFormHookContexts } from "@tanstack/react-form";

interface FieldValidationError {
  message: string;
}

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export type { FieldValidationError };
